import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import router from 'router';

import { logger, ConsoleTransport } from '@user-portal/logger';

import NotificationsContainer from 'containers/Notifications';

import NetworkErrorModal from './components/Modals/NetworkErrorModal';

import { store } from './store/configureStore';

import ThemeProvider from 'theme/provider';
import Sentry from './services/Sentry/SentryInstance';
import { DatadogRUM } from '@user-portal/datadog-rum';
import { useOneTrust } from './services/OneTrust/useOneTrust';
import { setHtmlLang } from './services/OneTrust/setHtmlLang';
import { initOneTrust } from './services/OneTrust';
import { initAmplitude } from './services/Analytics/useAmplitude';
import { initAmazonAnalytics } from './services/Analytics';

logger.addTransport(new ConsoleTransport());

Sentry.init();
initOneTrust(import.meta.env.ONE_TRUST_ID);
setHtmlLang();
initAmazonAnalytics();

DatadogRUM.init({
    applicationId: import.meta.env.DD_RUM_APPLICATION_ID,
    clientToken: import.meta.env.DD_RUM_CLIENT_TOKEN,
    serviceName: import.meta.env.DD_SERVICE_NAME,
    env: import.meta.env.ENV,
    version: import.meta.env.RELEASE_DATE,
    sessionSampleRate: Number(import.meta.env.DD_RUM_SAMPLING_RATE) || 20,
    replaySampleRate: Number(import.meta.env.DD_SESSIONREPLAY_SAMPLING_RATE) || 0,
});

function App() {
    useOneTrust({
        onConsent: () => {
            initAmplitude();
        },
    });

    return (
        <Provider store={store}>
            <ThemeProvider>
                <NetworkErrorModal />
                <NotificationsContainer />
                <RouterProvider router={router} />
            </ThemeProvider>
        </Provider>
    );
}

export default App;
